import { x } from '@xstyled/styled-components';
import React from 'react';
import { Flex } from '~/ui/flex/Flex';
import { LAYOUT_HALF_PAGE } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';

interface Props {
  side?: 'left' | 'right';
  card?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
}

const shadow =
  '0px -2px 4px rgba(0, 0, 0, 0.05), 0px 30px 30px rgba(0, 0, 0, 0.03), 0px 15px 20px rgba(0, 0, 0, 0.05)';

export type LayoutHalfPageDefinition = ItemDefinition<
  typeof LAYOUT_HALF_PAGE,
  Props
>;

export class LayoutHalfPage extends Item<typeof LAYOUT_HALF_PAGE, Props> {
  protected render({
    side = 'left',
    card = 'lg',
    children
  }: RenderProps<Props>) {
    return (
      <Flex
        w="100%"
        h={{ _: 'unset', lg: '100%' }}
        flexDirection={{ _: 'column', lg: 'row' }}
        className={'flexBoxInHalfPage'}
      >
        {side === 'right' && (
          <x.div w="50%" display={{ _: 'none', lg: 'block' }} />
        )}
        <x.div
          backgroundColor={{ _: 'white', [card]: 'transparent' }}
          boxShadow={{ _: shadow, [card]: 'none' }}
          w={{ _: 'unset', lg: '50%' }}
          h={{ _: 'unset', lg: '100%' }}
          p={{ _: 'lg', lg: 'xl' }}
          justifyContent={{ _: 'flex-start', lg: 'center' }}
          m={{ _: 'lg', lg: '0' }}
          mt={{ _: '45vh', lg: '0' }}
          display="flex"
          flexDirection="column"
          borderRadius="xl"
          zIndex={10}
        >
          {children}
        </x.div>
      </Flex>
    );
  }
}

registry[LAYOUT_HALF_PAGE] = LayoutHalfPage;
